export const GlamMag = {
  searchArticles: {
    url: "/mag",
    method: ["GET"]
  },
  getArticle: {
    url: "/mag/{id}",
    method: ["GET"]
  },
  getRelatedArticles: {
    url: "/mag/related/{id}",
    method: ["GET"]
  },
  cover: {
    url: "/mag/cover",
    method: ["GET"]
  },
  top: {
    url: "/mag/top/{limit}",
    method: ["GET"]
  }
};
